<template>
    <div class="cardTitle">
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-subtitle v-text="subTitle" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        subTitle: {
            type: String
        }
    }
};
</script>
